module.exports = __webpack_public_path__ + "img/Research-TrendyDAC.c4732be9.svg";